import React from 'react';

import {
  Dropdown 
} from '../../ui-helpers';

import {
  FingerSize,  
} from './Dimensions-styled';

import {TabContainer} from '../Tab-style';


interface Props {
  fingerSize:string,
  fingerSizeOptions:string[],
  onFingerSizeChange:(value:string)=>void,

  fingerSizeFormat:string,
  fingerSizeFormatOptions:string[],
  onFingerSizeFormatChange:(value:string)=>void,

  ringWidth:number,
  ringWidthOptions:number[],
  onRingWidthChange:(value:number)=>void,

  ringThickness:number,
  ringThicknessOptions:number[],
  onRingThicknessChange:(value:number)=>void,

  autoRatio:boolean,
  onAutoRatioChange:(value:boolean)=>void,

  checkoutIssues:('fingerSize'|'debug')[],

  scrolling:boolean
}

export default class extends React.Component<Props,{}> {
  constructor(props: Props) {
    super(props);
  };

  render = () => {
    const {
      fingerSize,
      onFingerSizeChange,
      fingerSizeFormat,
      fingerSizeFormatOptions,
      onFingerSizeFormatChange,
      ringWidth,
      ringWidthOptions,
      onRingWidthChange,
      ringThickness,
      ringThicknessOptions,
      onRingThicknessChange,
      autoRatio,
      onAutoRatioChange,
      checkoutIssues,
      scrolling
    } = this.props;

    const fingerSizeOptions = this.props.fingerSizeOptions.map((fso) => {
      fso = fso.replace('1/4', '¼');
      fso = fso.replace('1/2', '½');
      fso = fso.replace('3/4', '¾');
      return fso;
    });
   
    return(
      <TabContainer className="threed-configurator-menu-dimensions-tab">
        <FingerSize>    
           <Dropdown
            title="Width"            
            width={150}
            opacity={1}
            defaultOption={`${ringWidth} mm`}
            options={
              ringWidthOptions.map((r)=>({
                value:r,
                label:`${r} mm`
              }))
            }
            onChange={(width)=>{             
              onRingWidthChange(Number(width))
            }}
          />
          <Dropdown
            title="Thickness"           
            width={150}
            opacity={1}
            defaultOption={`${ringThickness} mm`}
            options={
              ringThicknessOptions.map((r)=>({
                value:r,
                label:`${r} mm`
              }))
            }
            onChange={onRingThicknessChange}            
          /> 
          <Dropdown
            title="Size"           
            width={150}
            opacity={1}
            defaultOption={fingerSize}
            options={
              fingerSizeOptions.map((s)=>({
                value:s,
                label:s
              }))
            }
            onChange={onFingerSizeChange}
            highlight={checkoutIssues.includes('fingerSize')}
          />
        </FingerSize>   
      </TabContainer>
    );
  };
};